<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('ALM.Section.DepositsPortfolio.DepositYields.Title')"
  >
    <div
      class="py-5 px-4 d-flex justify-start flex-column"
      style="height: 300px; width: 100%; gap:20px;"
    >
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.DepositsPortfolio.DepositYields.Fields.Yield') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ formatNumberShort(yieldPct) }}
          </p>
        </div>
        <v-progress-linear
          :value="100"
          color="#6E8EDF"
          height="10"
          rounded
          background-color="white"
        />
      </div>
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.DepositsPortfolio.DepositYields.Fields.InterestExpensePA') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ formatNumberShort(interestExpense) }}
          </p>
        </div>
        <v-progress-linear
          :value="100"
          color="#57C05B"
          height="10"
          rounded
          background-color="white"
        />
      </div>
    </div>
  </block-item-card>
</template>

<script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import { toDecimalSignificant, toNumberFormatNotationShort } from '@/lib/utils/helper'

export default {
  name      : 'DepositYields',
  components: {
    BlockItemCard
  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    Deposits: 'ALM.Deposits.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      chartHeight   : 120
    }
  },
  computed: {
    yieldPct () {
      return this.Deposits?.InterestExpense?.yield ? toDecimalSignificant(this.Deposits.InterestExpense.yield) + '%' : ''
    },
    currencySymbol () {
      return this.Deposits?.BaseCurrency?.displaySymbol || ''
    },
    interestExpense () {
      return this.Deposits?.InterestExpense?.interestExpensePa ? this.currencySymbol + toNumberFormatNotationShort(this.Deposits.InterestExpense.interestExpensePa) : ''
    }

  },

  mounted () {},

  methods: {
    formatNumberShort (value) {
      return toNumberFormatNotationShort(value)
    }

  }
}
</script>

<style scoped>
.border-top {
  border-top: 1px solid #e0e0e0;
}

.text-medium-emphasis {
  color: rgba(0, 0, 0, 0.6) !important;
}

.synthesis-brand-dark-blue--text {
  color: #041F30 !important;
}

.chart {
  width: 100%;
}
</style>
